import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LanguageSwitcherDesktop = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Récupère la langue actuelle à partir de l'URL
  const currentLang = location.pathname.split("/")[1] || "fr";

  // Change la langue tout en gardant le reste de l'URL inchangé
  const toggleLanguage = () => {
    const newLang = currentLang === "fr" ? "en" : "fr";
    const newPath = location.pathname.replace(/^\/(fr|en)/, `/${newLang}`);
    navigate(newPath);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="absolute top-2 right-4 bg-light px-3 py-1 rounded text-sm"
    >
      {currentLang === "fr" ? "English" : "Français"}
    </button>
  );
};

export default LanguageSwitcherDesktop;
